import React from "react";
import awardicon from "../../../../imgs/Awards-c.png";

const cardsData = [
  {
    id: 1,
    icon: awardicon,
    title: "15",
    subTitle: "Total Awards",
  },
  {
    id: 2,
    icon: awardicon,
    title: "15",
    subTitle: "Awards This Month",
  },
  {
    id: 3,
    icon: awardicon,
    title: "5",
    subTitle: "Outstanding Awards",
  },
  // {
  //   id: 4,
  //   icon: totalEmp,
  //   title: "10",
  //   subTitle: "Pending Approvals",
  // },
];

const DevicesCards = () => {
  return (
    <div className="">
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-3 gap-4 sm:ml-0 place-items-center ">
        {cardsData.map((card) => (
          <div
            key={card.id}
            className="flex w-full flex-row items-center gap-4 border border-border shadow bg-[#f8f8f8] rounded-md px-5 py-8"
          >
            <div className="w-11 h-1w-11">
              <img
                className="w-full h-full object-contain"
                src={card.icon}
                alt=""
              />
            </div>
            <div className="flex flex-col gap-1">
              <h2 className="text-3xl font-bold">{card.title}</h2>
              <p className="text-lg font-normal">{card.subTitle}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DevicesCards;
